import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Subject } from 'rxjs';
import { Gtp } from 'src/app/shared/gtp';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {
  public ContenidoTabla = null; //Valor Inicial para cargar el componente
  private ContenidoTablaObs = new Subject<any>(); //Valor modificado para cargar el componente
  public FormData = null; //Valor Inicial para cargar el componente
  private FormDataObs = new Subject<any>(); //Valor modificado para cargar el componente
  
  constructor(
    private http: HttpClient

  ) { }
  getContenidoTablaObs() {
    return this.ContenidoTablaObs.asObservable();
  }
  
  setContenidoTabla(obj) {
      this.ContenidoTablaObs.next(obj);
  }
  
  getFormDataObs() {
    return this.FormDataObs.asObservable();
  }
  
  setFormData(obj) {
      this.FormDataObs.next(obj);
  }

  getUsuariosListar() {
    return this.http.get(`${environment.baseUrl}usuario/get-users-listar`);
  }
  getUserListar() {
    return this.http.get(`${environment.baseUrl}usuario/get-user-list`);
  }

  usuarioGuardar(data) {
    //console.log(data)
    return this.http.post(`${environment.baseUrl}usuario/usuario-agregar`, data);
  }
  usuarioEditar(data) {
    return this.http.put(`${environment.baseUrl}usuario/usuario-update`, data);
  }
  usuarioEliminar(data) {
    console.log(data)
    return this.http.put(`${environment.baseUrl}usuario/eliminar-usuario`, data);
  }

}
